import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import '../../css/Anamnese.css';
import '../../css/Berg.css';

const PERGUNTAS_BERG = [
    { id: 0, titulo: "Posição sentada para posição em pé", instrucao: "Instruções: Levante-se. Tente não usar as mãos.", tipo: "radio" },
    { id: 1, titulo: "Permanecer em pé sem apoio", instrucao: "Instruções: Fique em pé por 2 minutos sem se apoiar.", tipo: "radio" },
    { id: 2, titulo: "Permanecer sentado sem apoio", instrucao: "Instruções: Sentado, sem apoiar as costas, braços cruzados por 2 min.", tipo: "radio" },
    { id: 3, titulo: "Posição em pé para posição sentada", instrucao: "Instruções: Por favor, sente-se.", tipo: "radio" },
    { id: 4, titulo: "Transferências", instrucao: "Instruções: Mude de uma cadeira com braço para uma sem braço.", tipo: "radio" },
    { id: 5, titulo: "Em pé (Olhos Fechados)", instrucao: "Instruções: Fique em pé e feche os olhos por 10 segundos.", tipo: "radio" },
    { id: 6, titulo: "Em pé (Pés Juntos)", instrucao: "Instruções: Junte seus pés e fique em pé sem se apoiar.", tipo: "radio" },
    { id: 7, titulo: "Alcançar à frente", instrucao: "Instruções: Braço 90º, alcance à frente o mais longe possível.", tipo: "radio" },
    { id: 8, titulo: "Pegar objeto do chão", instrucao: "Instruções: Pegue o objeto à frente dos seus pés.", tipo: "radio" },
    { id: 9, titulo: "Olhar para trás", instrucao: "Instruções: Olhe para trás por cima de ambos os ombros.", tipo: "radio" },
    { id: 10, titulo: "Girar 360º", instrucao: "Instruções: Gire completamente para ambos os lados.", tipo: "radio" },
    { id: 11, titulo: "Degrau / Banquinho", instrucao: "Instruções: Toque cada pé 4x no degrau (8 total).", tipo: "radio" },
    { id: 12, titulo: "Pé à frente (Tandem)", instrucao: "Instruções: Coloque um pé diretamente à frente do outro.", tipo: "radio" },
    { id: 13, titulo: "Um pé só", instrucao: "Instruções: Fique em uma perna só o máximo que puder.", tipo: "radio" }
];

const OPCOES_BERG = [
    { id: 0, opcoes: ["Capaz de levantar-se sem utilizar as mãos e estabilizar-se independentemente", "Capaz de levantar-se independentemente e estabilizar-se independentemente", "Capaz de levantar-se utilizando as mãos após diversas tentativas", "Necessita de ajuda mínima para levantar-se ou estabilizar-se", "Necessita de ajuda moderada ou máxima para levantar-se"] },
    { id: 1, opcoes: ["Capaz de permanecer em pé com segurança por 2 minutos", "Capaz de permanecer em pé por 2 minutos com supervisão", "Capaz de permanecer em pé por 30 segundos sem apoio", "Necessita de várias tentativas para permanecer em pé por 30 segundos", "Incapaz de permanecer em pé por 30 segundos sem apoio"] },
    { id: 2, opcoes: ["Capaz de permanecer sentado com segurança e com firmeza por 2 minutos", "Capaz de permanecer sentado por 2 minutos com supervisão", "Capaz de permanecer sentado por 30 segundos", "Capaz de permanecer sentado por 10 segundos", "Incapaz de permanecer sentado sem apoio por 10 segundos"] },
    { id: 3, opcoes: ["Senta-se com segurança, com uso mínimo das mãos", "Controla a descida utilizando as mãos", "Utiliza a parte posterior das pernas contra a cadeira", "Senta-se independentemente, mas tem descida sem controle", "Necessita de ajuda para sentar-se"] },
    { id: 4, opcoes: ["Capaz de transferir-se com segurança com uso mínimo das mãos", "Capaz de transferir-se com segurança com o uso das mãos", "Capaz de transferir-se seguindo orientações verbais e/ou supervisão", "Necessita de uma pessoa para ajudar", "Necessita de duas pessoas para ajudar ou supervisão total"] },
    { id: 5, opcoes: ["Capaz de permanecer em pé por 10 segundos com segurança", "Capaz de permanecer em pé por 10 segundos com supervisão", "Capaz de permanecer em pé por 3 segundos", "Incapaz de fechar os olhos por 3s, mas mantém-se em pé", "Necessita de ajuda para não cair"] },
    { id: 6, opcoes: ["Pés juntos, independentemente, seguro por 1 minuto", "Pés juntos, independentemente, supervisão por 1 minuto", "Pés juntos, independentemente, por 30 segundos", "Ajuda para posicionar-se, mas mantém por 15 segundos", "Incapaz de permanecer na posição por 15 segundos"] },
    { id: 7, opcoes: ["Pode avançar à frente mais que 25cm com segurança", "Pode avançar à frente mais que 12,5cm com segurança", "Pode avançar à frente mais que 5cm com segurança", "Pode avançar à frente, mas necessita de supervisão", "Perde o equilíbrio na tentativa ou necessita de apoio"] },
    { id: 8, opcoes: ["Capaz de pegar com facilidade e segurança", "Capaz de pegar, mas necessita de supervisão", "Incapaz de pegá-lo, mas fica a 2-5cm e mantém equilíbrio", "Incapaz de pegá-lo, necessitando de supervisão", "Incapaz de tentar ou necessita de ajuda"] },
    { id: 9, opcoes: ["Olha para trás de ambos os lados com boa distribuição de peso", "Olha para trás apenas de um lado", "Vira apenas para os lados, mas mantém o equilíbrio", "Necessita de supervisão para virar", "Necessita de ajuda para não cair"] },
    { id: 10, opcoes: ["Capaz de girar 360º com segurança em 4 segundos ou menos", "Capaz de girar 360º com segurança apenas de um lado em 4s", "Capaz de girar 360º com segurança, mas lentamente", "Necessita de supervisão próxima ou orientações verbais", "Necessita de ajuda enquanto gira"] },
    { id: 11, opcoes: ["Independente e seguro, completa 8 movimentos em 20s", "Independente e seguro, completa 8 movimentos em > 20s", "Capaz de completar 4 movimentos sem ajuda", "Capaz de completar mais de 2 movimentos com ajuda mínima", "Incapaz de tentar ou necessita de ajuda"] },
    { id: 12, opcoes: ["Pé imediatamente à frente do outro, 30 segundos", "Pé um pouco à frente e para o lado, 30 segundos", "Pequeno passo independentemente, 30 segundos", "Precisa de ajuda para dar o passo, mantém por 15s", "Perde o equilíbrio ao tentar dar o passo"] },
    { id: 13, opcoes: ["Levanta perna independentemente e mantém > 10s", "Levanta perna independentemente e mantém 5-10s", "Levanta perna independentemente e mantém > 3s", "Tenta levantar a perna, mas não mantém 3s", "Incapaz de tentar ou necessita de ajuda"] }
];

function EscalaBerg({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
    const [etapa, setEtapa] = useState(1);
    const [showInfo, setShowInfo] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS_BERG.map(p => ({ id: p.id, valor: null }))
    );

    useEffect(() => {
        if (evaluationData?.escalaBerg?.respostas) {
            setRespostasSelecionadas(evaluationData.escalaBerg.respostas);
        }
    }, [evaluationData]);

    const totalEtapas = 5;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    // Lógica de atualização
    const atualizarResposta = (perguntaId, pontos) => {
        setRespostasSelecionadas(prev => prev.map(item =>
            item.id === perguntaId ? { ...item, valor: pontos } : item
        ));
    };

    // Cálculo da pontuação total
    const pesoTotal = respostasSelecionadas.reduce((acc, r) => acc + (r.valor || 0), 0);

    const handleBergSalvar = async () => {
        const payload = {
            escalaBerg: { respostas: respostasSelecionadas },
            evaluationId
        };

        try {
            const response = await api.post(`/api/student/${aluno.id}/evaluation/escala-berg`, payload, { withCredentials: true });
            if (response.status === 200) {
                if (response.data.evaluationId && setEvaluationId) {
                    if (!evaluationId) {
                        if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
                        aluno.avaliacoesRealizadas.push({
                            id: response.data.evaluationId,
                            data: new Date().toISOString()
                        });
                    }
                    setEvaluationId(response.data.evaluationId);
                }
                if (updateEvaluationData) {
                    updateEvaluationData({ escalaBerg: payload.escalaBerg });
                }
                setIsModalOpen(true);
            }
        } catch (error) {
            console.error('Erro ao salvar Escala de Berg:', error);
        }
    };

    const renderPerguntaBerg = (pergunta) => {
        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const valorAtual = rObj ? rObj.valor : null;
        const opcoesDaPergunta = OPCOES_BERG.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="question-title">{pergunta.id + 1}. {pergunta.titulo}</div>
                <p className="tit-instrucao">{pergunta.instrucao}</p>
                <div className="answer-container berg-container">
                    {opcoesDaPergunta.map((opt, index) => {
                        const pontosSugeridos = 4 - index; // Primeira opção = 4 pts, última = 0 pts
                        return (
                            <label className="answer-item" key={index}>
                                <input
                                    type="radio"
                                    className="answer-radio"
                                    checked={valorAtual === pontosSugeridos}
                                    onChange={() => atualizarResposta(pergunta.id, pontosSugeridos)}
                                />
                                <p className="answer-title berg-titles">{opt}</p>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className='avaliacao-container'>
            <div className="avaliacao-content">

                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">{PERGUNTAS_BERG.slice(0, 2).map(renderPerguntaBerg)}</div>
                        <div className="questions-right">{PERGUNTAS_BERG.slice(2, 4).map(renderPerguntaBerg)}</div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">{PERGUNTAS_BERG.slice(4, 6).map(renderPerguntaBerg)}</div>
                        <div className="questions-right">{PERGUNTAS_BERG.slice(6, 8).map(renderPerguntaBerg)}</div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">{PERGUNTAS_BERG.slice(8, 10).map(renderPerguntaBerg)}</div>
                        <div className="questions-right">{PERGUNTAS_BERG.slice(10, 12).map(renderPerguntaBerg)}</div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">{PERGUNTAS_BERG.slice(12, 14).map(renderPerguntaBerg)}</div>
                        <div className="questions-right"></div>
                    </div>
                )}

                {etapa === 5 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            <div className="question-title">Resultado Consolidado</div>
                            <div className="indice-cap-func-quest">
                                Total: <strong>{pesoTotal} pts</strong> <br />
                                {(pesoTotal >= 41) ? "Baixo Risco" : (pesoTotal >= 21) ? "Risco Médio" : "Alto Risco"}
                            </div>
                        </div>
                        <div className="questions-right">
                            <div className="interpretacao-cap-func-quest">
                                <p className={pesoTotal >= 41 ? "risko-1" : ""}>41-56: Independente (Baixo Risco)</p>
                                <p className={pesoTotal >= 21 && pesoTotal <= 40 ? "risko-3" : ""}>21-40: Auxílio p/ Deambular (Risco Médio)</p>
                                <p className={pesoTotal < 21 ? "risko-5" : ""}>0-20: Cadeirante (Alto Risco)</p>
                            </div>
                        </div>
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            <button type="button" className="next-prev-button" onClick={() => setEtapa(etapa - 1)} disabled={etapa === 1}>Voltar</button>
                            {etapa < totalEtapas ? (
                                <button type="button" className="next-prev-button" onClick={() => setEtapa(etapa + 1)}>Próximo</button>
                            ) : (
                                <button type="button" className="next-prev-button" onClick={handleBergSalvar}>Salvar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>

                    <div className="info-box-container" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                        <div className="info-button">
                            <HelpCircle size={20} /> Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p>
                                    A Escala de Berg é um instrumento utilizado para avaliar o equilíbrio funcional e o risco de quedas, especialmente em idosos, por meio da análise de tarefas como sentar, levantar, permanecer em pé, transferências e mudanças de posição.
                                    <br/><br/>
                                    Sua aplicação permite identificar alterações no controle postural, equilíbrio estático e dinâmico, fornecendo informações importantes sobre mobilidade e segurança funcional.
                                    <br/><br/>
                                    Essa avaliação é amplamente utilizada para orientar estratégias de prevenção de quedas, prescrição de exercícios e promoção de maior independência, estabilidade e qualidade de vida.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Modal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} contentLabel="Confirmacao" className="modal-next" overlayClassName="popup-overlay">
                <p className="popupNext-h1">Escala de Berg finalizada!</p>
                <p className="popupNext-h2">Deseja ir para o ParQ?</p>
                <div className="sub-pagination-buttons">
                    <button className="next-prev-button" type="button" onClick={() => setActiveTab("ParQ")}>Sim</button>
                    <button className="next-prev-button" type="button" onClick={() => setIsModalOpen(false)}>Não</button>
                </div>
            </Modal>
        </div>
    );
}

export default EscalaBerg;